export type Size = { width: number; height: number };
export type Position = { x: number; y: number };

const EDGE = 8;

/** Keeps a floating menu fully inside the window, even near the edges. */
export function clampMenu(at: Position, size: Size, viewport: Size): Position {
  return {
    x: Math.max(EDGE, Math.min(at.x, viewport.width - size.width - EDGE)),
    y: Math.max(EDGE, Math.min(at.y, viewport.height - size.height - EDGE)),
  };
}

export function submenuSide(
  parentX: number,
  parentWidth: number,
  submenuWidth: number,
  viewport: Size,
): "left" | "right" {
  const fitsRight = parentX + parentWidth + submenuWidth + EDGE <= viewport.width;
  const fitsLeft = parentX - submenuWidth - EDGE >= 0;
  if (fitsRight) return "right";
  return fitsLeft ? "left" : "right";
}
